export default "__VITE_ASSET__nfQSKtDR__"